module.exports = __webpack_public_path__ + "media/images/logo_footer@2x-b8e72e92b434ab27ca9c91e831f60b2f.png";